import { render, staticRenderFns } from "./unsubscribe.vue?vue&type=template&id=1abedc2a"
import script from "./unsubscribe.vue?vue&type=script&lang=js"
export * from "./unsubscribe.vue?vue&type=script&lang=js"
import style0 from "./unsubscribe.vue?vue&type=style&index=0&id=1abedc2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QRadio,QInput,QBtn});
